import React from 'react'
import { QuizQuestionWrapper } from '../../QuizQuestionWrapper'
import { useContactInfo } from './ContactInfo.hook'
import './ContactInfo.scss'
import { OutlinedTextField, PhoneNumber } from 'src/common/components'
import { Dropdown } from 'src/common/components/select/Dropdown'
import { QuizType, REFERRAL_SOURCES } from 'src/pages/shared'
import MetBeforeModal from 'src/pages/quiz/components/NewFlow/ContactInfo/components/MetBeforeModal'
import { useLocation } from 'react-router-dom'
import { REDIRECT_PATH } from 'src/helpers/path'

export const ContactInfo = () => {
  const query = new URLSearchParams(useLocation().search)
  const isPinterestFlow = query.get('quizType') === QuizType.PINTEREST
  const {
    handleNext,
    handleBack,
    weddingDateData,
    formError,
    handleChangeInput,
    handleChangePhoneNumber,
    referralSource,
    handleChangeReferralSource,
    nextDisabled,
    loading,
    showMetBeforePopup,
    handleCloseMetBeforePopup,
    emailSuggestion,
    emailWarning,
    handleAcceptSuggestion,
  } = useContactInfo(query.get('quizType') as QuizType)

  return (
    <>
      <QuizQuestionWrapper
        titleStep="CONTACT INFO"
        title="Ready to see your proposal?"
        subtitle={isPinterestFlow ? '' : `(You’ll use this email to login later)`}
        nextAction={{
          disabled: true,
        }}
        backAction={{
          onAction: handleBack,
        }}
        customCss={{
          title: 'title-bold',
          content: 'contact-info-wrapper',
        }}
        step={7}
        total={7}
        className={isPinterestFlow ? 'pinterest-flow contact-info' : ''}
      >
        <div className="contact-info-section">
          <OutlinedTextField
            wrapperClass="mb-10px"
            inputClass="email"
            id="emailAddressId"
            value={weddingDateData.emailAddress ?? ''}
            type="text"
            name="emailAddress"
            onChange={handleChangeInput}
            label="Email address"
            isError={formError.emailAddress}
            errorMsg="Invalid email!"
          />
          {emailSuggestion && (
            <div className="email-suggestion-message">
              <span>Did you mean </span>
              <button className="email-suggestion-link" onClick={handleAcceptSuggestion} type="button">
                {emailSuggestion}
              </button>
              <span>?</span>
            </div>
          )}
          {emailWarning && !emailSuggestion && <div className="email-warning-message">{emailWarning}</div>}
          {isPinterestFlow && <span className="form-sub-text">You’ll use your email to login to your proposal.</span>}
          {!isPinterestFlow && (
            <div className="input-wrapper mb-10px">
              <div className={`floating-label-wrapper ${weddingDateData.phoneNumber ? 'has-value' : ''}`}>
                <label className="label">
                  Phone number <span className="optional-label"> (optional)</span>
                </label>
                <PhoneNumber
                  id="phoneNumberId"
                  country="US"
                  value={weddingDateData.phoneNumber}
                  onChange={handleChangePhoneNumber}
                  inputMode="tel"
                  className={`input w-100 ${formError.phoneNumber ? 'border-red' : ''}`}
                  placeholder=" "
                  name="phoneNumber"
                />
              </div>
              <p className="phone-help-text">Add your phone number for priority 1:1 support from Poppy</p>
              {formError.phoneNumber ? (
                <div className="error">Invalid phone number!</div>
              ) : (
                <div className="error">&nbsp;</div>
              )}
            </div>
          )}
          <h2 className="ref-text">
            Where did you hear about us? <span className="optional-label">(optional)</span>
          </h2>
          <Dropdown
            id="referralSourceId"
            className="ref-dropdown"
            options={REFERRAL_SOURCES}
            placeholder="Choose one"
            value={referralSource ?? undefined}
            handleChange={handleChangeReferralSource}
          />
          <div className="action-box-wrapper mt-34px mb-30px">
            <button
              disabled={nextDisabled || loading}
              className={`button white-space-wrap see-your-proposal-btn ${loading ? 'loading' : ''}`}
              onClick={handleNext}
            >
              {isPinterestFlow ? 'GET MY PROPOSAL' : 'SEE YOUR PROPOSAL'}
            </button>
          </div>
          <p className="get-started-section__compliance notice-text">
            By providing your phone number, you agree to receive recurring automated marketing text messages from Poppy
            Flowers at the cell number used when signing up. Consent is not a condition of any purchase. Msg & data
            rates may apply. Unsubscribe at anytime. See{' '}
            <a href={REDIRECT_PATH.TERMS} target="_blank" rel="noreferrer">
              Terms
            </a>
            {' & '}
            <a href={REDIRECT_PATH.PRIVACY} target="_blank" rel="noreferrer">
              Privacy.
            </a>
          </p>
        </div>
        <MetBeforeModal
          classes="contact-info-page"
          isOpen={showMetBeforePopup}
          onClose={handleCloseMetBeforePopup}
          contact={{ emailAddress: weddingDateData.emailAddress, phoneNumber: weddingDateData.phoneNumber }}
        />
      </QuizQuestionWrapper>
    </>
  )
}
